import * as actionTypes from 'src/actions';

const initialState = {
    loading: false,
    usuarios: []
};

const usuariosReducer = (state = {}, action) => {
    switch (action.type) {
        case actionTypes.SESSION_USUARIOS_REQUEST:
            return { loading: true };
        case actionTypes.SESSION_USUARIOS_SUCCESS: {
            return {
                ...initialState,
                usuarios: action.payload
            };
        }
        case actionTypes.SESSION_USUARIOS_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export default usuariosReducer;
